import React from 'react'
import { useLocation } from 'react-router-dom'
import { Box } from '@mantine/core'
import { TOP_NAV_HEIGHT } from './TopNavBar'
import { PRIMARY_SIDEBAR_WIDTH } from './PrimarySidebarNav'
import { BOTTOM_NAB_HEIGHT } from './BottomNavBar'
import {
  MAIN_CONTENT_HORIZONTAL_GUTTER_PX,
  pathnameUsesMainContentHorizontalGutter,
  pathnameSkipsTopPadding
} from './mainContentHorizontalGutter'

type AppShellLayoutProps = {
  desktopNav: boolean;
  children: React.ReactNode;
};

export default function AppShellLayout ({ desktopNav, children }: AppShellLayoutProps) {
  const { pathname } = useLocation()
  const horizontalGutter = pathnameUsesMainContentHorizontalGutter(pathname)
  const skipTopPadding = pathnameSkipsTopPadding(pathname)

  return (
    <Box
      component="main"
      sx={{
        marginTop: TOP_NAV_HEIGHT,
        marginLeft: desktopNav ? PRIMARY_SIDEBAR_WIDTH : 0,
        marginBottom: desktopNav ? 0 : BOTTOM_NAB_HEIGHT,
        display: 'flex',
        flexDirection: 'column',
        minHeight: desktopNav
          ? `calc(100vh - ${TOP_NAV_HEIGHT}px)`
          : `calc(100vh - ${TOP_NAV_HEIGHT}px - ${BOTTOM_NAB_HEIGHT}px)`,
        
      }}
    >
      {/*
        Do not use Mantine <Container> here: it applies marginLeft/marginRight auto + max-width
        on .mantine-Container-root, which shrinks/center-aligns the whole main column and breaks
        full-bleed layouts (e.g. profiles). Route-level components can use <Page /> or their own
        Container when they want a centered max-width column.
      */}
      <Box
        sx={{
          flex: 1,
          width: '100%',
          minWidth: 0,
          paddingTop: skipTopPadding ? 0 : 16,
          paddingBottom: 24,
          paddingLeft: horizontalGutter ? MAIN_CONTENT_HORIZONTAL_GUTTER_PX : 0,
          paddingRight: horizontalGutter ? MAIN_CONTENT_HORIZONTAL_GUTTER_PX : 0,
          boxSizing: 'border-box'
        }}
      >
        {children}
      </Box>
    </Box>
  )
}
